import LeagueManagementModule from '@/modules/league-management';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/dashboard/fantasy/league-management/')({
  component: LeagueManagementPage,
});

function LeagueManagementPage() {
  return <LeagueManagementModule />;
}
